import { StorageService } from '../tools/storage.service';
import { Roles } from './api.service';
import { FormGroup, ValidatorFn } from '@angular/forms';
import { Country } from '../Support/panier/panier.component';
import moment from 'moment';

export enum ColorKind {
    Classic,
    ClassicRep,
    ClassicRepExtended,
    Colorblind
}

export class Utils {
    public static storage: StorageService = new StorageService(null, null, null)

    // Indique si une chaîne est non définie, null, vide ou des espaces blancs;
    public static IsNullOrWhiteSpace(s: string): boolean {
        return (s == undefined || s == null || s == "" || s.trim() == "");
    }

    public static IsPreprod() {
        return window.document.location.href.indexOf('https://ww2.ixellweblab.net') >= 0 || window.document.location.href.indexOf('https://www.ixellweblab.net') >= 0;
    }

    public static isAdminLacour(role: Roles) {
        if (role & Roles.AdminLacour)
            return true;
        else
            return false;
    }

    public static isAdminRenault(role: Roles) {
        if (role & Roles.AdminRenault)
            return true;
        else
            return false;
    }

    public static isAdminRenaultPays(role: Roles) {
        if (role & Roles.AdminRenaultPays)
            return true;
        else
            return false;
    }

    public static isRT(role: Roles) {
        if (role & Roles.RT)
            return true;
        else
            return false;
    }

    public static isFormateur(role: Roles) {
        if (role & Roles.Formateur)
            return true;
        else
            return false;
    }

    public static isMCI(role: Roles) {
        if (role & Roles.MCI)
            return true;
        else
            return false;
    }

    public static isCTC(role: Roles) {
        if (role & Roles.CTC)
            return true;
        else
            return false;
    }

    public static isUserIxell(role: Roles) {
        if (role & Roles.UserIxell)
            return true;
        else
            return false;
    }

    public static isUserColor(role: Roles) {
        if (role & Roles.UserColor)
            return true;
        else
            return false;
    }

    public static isTechLine(role: Roles) {
        if (role & Roles.TechLine)
            return true;
        else
            return false;
    }

    public static isFournisseur(role: Roles) {
        if (role & Roles.Fournisseur)
            return true;
        else
            return false;
    }

    public static isAxalta(role: Roles) {
        if (role & Roles.Axalta)
            return true;
        else
            return false;
    }

    public static isAkzo(role: Roles) {
        //if (role & Roles.Axalta)
        //    return true;
        //else
            return false;
    }

    public static isAttum(role: Roles) {
        if (role & Roles.Attum || this.storage.get('isAttum') == "true")
            return true;
        else
            return false;
    }

    public static haveGPI() {
        if (this.storage.get('haveGPI') == "true")
            return true;
        else
            return false;
    }

    public static haveCWI() {
        if (this.storage.get('haveCWI') == "true")
            return true;
        else
            return false;
    }

    public static isColorBook(role: Roles) {
        if (role == Roles.ColorBook)
            return true;
        else
            return false;
    }

    public static isMonitoring(role: Roles) {
        if (role & Roles.Monitoring)
            return true;
        else
            return false;
    }

    public static isHotline(role: Roles) {
        if (role & Roles.Hotline)
            return true;
        else
            return false;
    }

    public static isRespHotline(role: Roles) {
        if (role & Roles.ResponsableHotline)
            return true;
        else
            return false;
    }

    public static isFrench() {
        if (this.storage.get("actualLanguage") == "fr")
            return true;
        else
            return false;
    }


    public static droitUtilisateurIxell: number = 248;
    public static droitCTCIxell: number = 255;
    public static droitAdminLacour: number = 257;
    public static droitFormateur: number = 283;
    public static droitReferentTechnique: number = 258;
    public static droitTechLine: number = 265;
    public static droitFournisseur: number = 904;
    public static droitAkzo: number = 905;
    public static droitAxalta: number = 268;
    public static droitAttum: number = 269;
    public static droitAdminRenault: number = 271;
    public static droitAdminRenaultPays: number = 903;
    public static droitMCI: number = 272;
    public static droitHotline: number = 275;
    public static droitResponsableHotline: number = 276;
    public static droitPreProd: number = 278;
    public static droitMonitoring = 281;
    public static InternCorporate: number = 900;
    public static ClientCorporate: number = 901;
    public static DroitGPI: number = 902;


    public static countries() {
        return [
            { name: "Germany", vo: "Deutschland", fr: "Allemagne", txt: "scaleform.allemagne", tvaRegEx: "^DE[0-9]{9}$" },
            { name: "United Kingdom", vo: "United Kingdom", fr: "Royaume-Uni", txt: "scaleform.angleterre", tvaRegEx: "^GB([0-9]{9}|[0-9]{12}|GD[0-9]{3}|HA[0-9]{3})$" },
            { name: "Spain", vo: "España", fr: "Espagne", txt: "scaleform.espagne", tvaRegEx: "^ES[A-Z0-9][0-9]{7}[A-Z0-9]$" },
            { name: "France", vo: "France", fr: "France", txt: "scaleform.france", tvaRegEx: "^FR[0-9A-Z]{2}[0-9]{9}$" },
            { name: "Belgium", vo: "Belgique", fr: "Belgique", txt: "scaleform.belgique", tvaRegEx: "^BE0[0-9]{9}$" },
            { name: "Italy", vo: "Italia", fr: "Italie", txt: "scaleform.italie", tvaRegEx: "^IT[0-9]{11}$" },
            { name: "Luxembourg", vo: "Luxembourg", fr: "Luxembourg", txt: "scaleform.luxembourg", tvaRegEx: "" },
            { name: "Netherlands", vo: "Nederland", fr: "Pays-Bas", txt: "scaleform.paysbas", tvaRegEx: "^NL[0-9]{9}B[0-9]{2}$" },
            { name: "Poland", vo: "Polska", fr: "Pologne", txt: "scaleform.pologne", tvaRegEx: "^PL[0-9]{10}$" },
            { name: "Portugal", vo: "Portugal", fr: "Portugal", txt: "scaleform.portugal", tvaRegEx: "^PT[0-9]{9}$" },
            { name: "Romania", vo: "România", fr: "Roumanie", txt: "scaleform.roumanie", tvaRegEx: "^RO[0-9]{2,10}$" },
            { name: "Turkey", vo: "Türkiye", fr: "Turquie", txt: "scaleform.turquie", tvaRegEx: "" },
            { name: "Mayotte", vo: "Mayotte", fr: "Mayotte", txt: "scaleform.mayotte", tvaRegEx: "" },
            { name: "Ivory Coast", vo: "Côte d’Ivoire", fr: "Côte d’Ivoire", txt: "scaleform.coteIvoire", tvaRegEx: "" },
            { name: "Cameroon", vo: "Cameroun", fr: "Cameroun", txt: "scaleform.cameroun", tvaRegEx: "" },
            { name: "Austria", vo: "Österreich", fr: "Österreich", txt: "scaleform.autriche", tvaRegEx: "^ATU[0-9]{8}$" }
        ];
    }

    public static countriesFiltered(country: string) {
        let countries = this.countries();
        return [countries.find(c => c.name == country || c.vo == country)];
    }

    public static languages() {
        return [
            { name: "German", txt: "scaleform.allemand", code: "de" },
            { name: "English", txt: "scaleform.anglais", code: "en" },
            { name: "Spanish", txt: "scaleform.espagnol", code: "es" },
            { name: "French", txt: "scaleform.français", code: "fr" },
            { name: "Italian", txt: "scaleform.italien", code: "it" },
            { name: "Dutch", txt: "scaleform.neerlandais", code: "nl" },
            { name: "Romanian", txt: "scaleform.roumain", code: "ro" },
            { name: "Portuguese", txt: "scaleform.portugais", code: "pt" },
            { name: "Polish", txt: "scaleform.polonais", code: "pl" },
            { name: "Turkish", txt: "scaleform.turc", code: "tr" }
        ];
    }

    public static deleteStorageData() {
        Utils.storage.remove("manufacturer");
        Utils.storage.remove("model");
        Utils.storage.remove("previous");
        Utils.storage.remove("colorCode");
        Utils.storage.remove("scale");
    }

    public static isIxellColorWeb(id: string) {
        if (id == "1")
            return true;
        else
            return false;
    }
    public static isIxellColorTouch(id: string) {
        if (id == "2")
            return true;
        else
            return false;
    }
    public static isIxellColorConnect(id: string) {
        if (id == "4")
            return true;
        else
            return false;
    }
    public static isIxellColorPro(id: string) {
        if (id == "8")
            return true;
        else
            return false;
    }

    /**
   * Ouvre dans un nouvel onglet
   * @param base64Content
   */
    public static openBase64Content(base64Content: any, NameFile: string) {
        fetch(base64Content)
            .then(res => res.blob())
            .then(blob => {
                var objectUrl = URL.createObjectURL(blob);
                return window.open(objectUrl, "_blank");
                //return window.open(window.URL.createObjectURL(blob), "_blank");
            })
    }

    /*
     * arrondie d'un nombre avec precision
     **/
    public static roundDecimal(nombre: number, precision: number) {
        var precision = precision || 2;
        var tmp = Math.pow(10, precision);
        return Math.round(nombre * tmp) / tmp;
    }

    /**
     * Renvoie un tableau de couleur selon les paramètres donnés
     * @param vals poids des couleurs à renvoyer
     * @param kind type de colorisation
     */
    public static makeColors(vals: number[], kind: ColorKind) {
        if (kind == ColorKind.Classic)
            return Utils.getColorArray(vals.length);
        else if (kind == ColorKind.ClassicRep)
            return Utils.getColorArrayRep(vals);
        else if (kind == ColorKind.ClassicRepExtended)
            return Utils.getColorArrayRepEx(vals);
        else if (kind == ColorKind.Colorblind)
            return ["#3182BD", "#FAB92D", "#969696"];
        else
            return [];
    }

    static getColorArray(nb: number): string[] {
        let split: number = 360.0 / (nb + 1);

        var arr: string[] = [];

        for (let i = 0; i < 360.0; i += split) {
            let rgb: number[] = Utils.hsvToRgb(i, 0.80, 0.95);
            let conv: string = Utils.rgb2hex(rgb[0], rgb[1], rgb[2]);

            arr.push(conv);
        }

        return arr;
    }

    static getColorArrayRep(vals: number[]): string[] {
        let sum = vals.reduce((partialSum, a) => partialSum + a, 0);
        sum += sum * 0.1;

        var arr: string[] = [];

        var totalTurn = 0.0;

        for (let i = 0; i < vals.length; i++) {
            let toAdd = vals[i] * 360.0 / sum;

            let rgb: number[] = Utils.hsvToRgb(totalTurn + (toAdd / 2), 0.80, 0.95);
            let conv: string = Utils.rgb2hex(rgb[0], rgb[1], rgb[2]);

            totalTurn += toAdd;

            arr.push(conv);
        }

        return arr;
    }

    static getColorArrayRepEx(vals: number[]): string[] {
        let sum = vals.reduce((partialSum, a) => partialSum + a, 0);
        sum += sum * 0.1;

        var arr: string[] = [];

        var totalTurn = 0.0;

        for (let i = 0; i < vals.length; i++) {
            let toAdd = vals[i] * 720.0 / sum;

            let fakeTotal = (totalTurn + (toAdd / 2));
            let totalAsTurn = fakeTotal % 360.0;
            let rgb: number[] = Utils.hsvToRgb(totalAsTurn, (fakeTotal > 360.0) ? 0.608 : 0.80, (fakeTotal > 360.0) ? 0.72 : 0.95);
            let conv: string = Utils.rgb2hex(rgb[0], rgb[1], rgb[2]);

            totalTurn += toAdd;

            arr.push(conv);
        }

        return arr;
    }

    static hsvToRgb(h: number, s: number, v: number): number[] {
        let r = 0, g = 0, b = 0;

        h = h % 360;

        if (h >= 0 && h <= 60) {
            r = 255;
            g = h * 255 / 60;
            b = 0;
        }
        else if (h > 60 && h <= 120) {
            r = (60 - (h - 60)) * 255 / 60;
            g = 255;
            b = 0;
        }
        else if (h > 120 && h <= 180) {
            r = 0;
            g = 255;
            b = (h - 120) * 255 / 60;
        }
        else if (h > 180 && h <= 240) {
            r = 0;
            g = (60 - (h - 180)) * 255 / 60;
            b = 255;
        }
        else if (h > 240 && h <= 300) {
            r = (h - 240) * 255 / 60;
            g = 0;
            b = 255;
        }
        else if (h > 300 && h <= 360) {
            r = 255;
            g = 0;
            b = (60 - (h - 300)) * 255 / 60;
        }

        s = 1.0 - s;
        let m = Math.max(r, g, b);
        r += (m - r) * s;
        g += (m - g) * s;
        b += (m - b) * s;

        r *= v;
        g *= v;
        b *= v;

        return [Math.round(r), Math.round(g), Math.round(b)];
    }

    static rgb2hex(r: number, g: number, b: number): string {
        return "#"
            + ("00" + r.toString(16)).slice(-2)
            + ("00" + g.toString(16)).slice(-2)
            + ("00" + b.toString(16)).slice(-2);
    }

    // https://math.stackexchange.com/questions/830143/need-is-the-point-in-the-pie
    public static isPointInPieSlice(pieSlice: { radius: number, startAngle: number, lenAngle: number }, point: { x: number, y: number }): boolean {
        if (Math.sqrt((point.x * point.x) + (point.y * point.y)) > pieSlice.radius)
            return false;

        let a_t = Math.atan2(point.x, point.y);
        while (a_t < 0)
            a_t += (2 * Math.PI);

        if (pieSlice.startAngle > a_t)
            return false;

        if (a_t >= (pieSlice.startAngle + pieSlice.lenAngle))
            return false;

        return true;
    }

    public static isPolygonInPieSlice(polygon: { x: number, y: number }[], pieSlice: { radius: number, startAngle: number, lenAngle: number }): boolean {
        for (let point of polygon)
            if (!Utils.isPointInPieSlice(pieSlice, point))
                return false;

        return true;
    }

    public static doesPolygonCollideWithPieSlice(polygon: { x: number, y: number }[], pieSlice: { radius: number, startAngle: number, lenAngle: number }): boolean {
        for (let point of polygon)
            if (Utils.isPointInPieSlice(pieSlice, point))
                return true;

        return false;
    }

    public static isDate(v: any): boolean {
        return ((typeof (v) === 'object') && (v.constructor.name == 'Date')) || (isNaN(Number(v)) && moment(v, moment.ISO_8601, true).isValid());
    }

    // https://stackoverflow.com/a/18639999

    private static readonly crcTable: number[] = (() => {
        let c;
        let crcTable = [];

        for (let n = 0; n < 256; n++) {
            c = n;

            for (let k = 0; k < 8; k++) {
                c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
            }

            crcTable[n] = c;
        }

        return crcTable;
    })();

    public static crc32(data: Uint8Array) {
        let crc = 0 ^ (-1);

        for (let i = 0; i < data.length; i++) {
            crc = (crc >>> 8) ^ this.crcTable[(crc ^ data[i]) & 0xFF];
        }

        return (crc ^ (-1)) >>> 0;
    }
}
